import { render, staticRenderFns } from "./modalHistoricoConversa.vue?vue&type=template&id=016f5f40&scoped=true&lang=pug&"
import script from "./modalHistoricoConversa.vue?vue&type=script&lang=js&"
export * from "./modalHistoricoConversa.vue?vue&type=script&lang=js&"
import style0 from "./modalHistoricoConversa.vue?vue&type=style&index=0&id=016f5f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f5f40",
  null
  
)

export default component.exports